import { action, Action, createStore, persist } from "easy-peasy";
import { User, Payload } from "../type";
import ls from "localstorage-slim";
import { Role, Settings } from "../../utils/enum";

export interface EasyPeasyStore {
  roles: Role[];
  isSideMenuOpen: boolean;
  setting: string;
  settings: Settings[];
  activeSettingsTab: string;
  user: User;
  addUser: Action<this, Payload>;
  setAuthUserId: Action<this, string>;
  setUserFromMe: Action<this, { id: string; username: string; email: string }>;
  updateSetting: Action<this, string>;
  updateSettings: Action<this, Settings[]>;
  setActiveSettingsTab: Action<this, string>;
  toggleSideMenu: Action<this, boolean>;
}

const initialState = {
  isSideMenuOpen: true,
  setting: "profile",
  settings: [],
  activeSettingsTab: "Profile",
  roles: [],
  user: {
    email: "",
    name: "",
    id:"",
  },
};

export const store = createStore<EasyPeasyStore>(
  persist(
    {
      ...initialState,

      addUser: action((state: any, payload: Payload) => {
        state.user = payload.user;
        state.roles = payload.roles;
        state.setting = payload.setting;
        state.settings = payload.settings || [];
      }),

      setAuthUserId: action((state: any, userId: string) => {
        state.user.id = userId;
      }),

      setUserFromMe: action((state: any, payload: { id: string; username: string; email: string }) => {
        state.user.id = payload.id;
        state.user.name = payload.username;
        state.user.email = payload.email;
      }),

      updateSetting: action((state: any, payload: string) => {
        state.setting = payload;
      }),

      updateSettings: action((state: any, payload: Settings[]) => {
        state.settings = payload;
      }),

      setActiveSettingsTab: action((state: any, payload: string) => {
        state.activeSettingsTab = payload;
      }),

      toggleSideMenu: action((state: any, payload: boolean) => {
        state.isSideMenuOpen = payload;
      }),
    },
    {
      storage: {
        getItem: async function (key) {
          const value: any = ls.get(key, { decrypt: true });
          return value;
        },

        setItem: function (key, value) {
          ls.set(key, value);
        },

        removeItem: function (key) {
          ls.remove(key);
        },
      },
      allow: [
        "user",
        "isSideMenuOpen",
        "setting",
        "settings",
        "roles",
        "activeSettingsTab",
      ],
    }
  ),
  {
    name: "client-dashboard",
  }
);
